/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Ensure/renew meeting notifications subscriptions across providers.
 */
export interface MeetingNotificationsEnsureParams {
  leadHours?: number;
  renewThresholdHours?: number;
}
